export const isDataAttributeProp = (key: string) => key.indexOf("data-") === 0

type ObjectType = { [key: string]: any }

export const stripDataAttributesFromProps = (props: ObjectType): ObjectType =>
  Object.entries(props).reduce(
    (acc, [key, value]) => (isDataAttributeProp(key) ? { ...acc, [key]: value } : acc),
    {},
  )
